module.exports = __webpack_public_path__ + "static/media/blue_star.240acc26.svg";